"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnFiNok = exports.EnFiDkk = exports.EnFiSek = exports.EnFiUsd = exports.EnFiEur = void 0;
class EnFiEur {
    constructor() {
        this.locale = "en-fi";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "-C n",
        };
    }
}
exports.EnFiEur = EnFiEur;
class EnFiUsd {
    constructor() {
        this.locale = "en-fi";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "-C n",
        };
    }
}
exports.EnFiUsd = EnFiUsd;
class EnFiSek {
    constructor() {
        this.locale = "en-fi";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "SEK",
            symbol: "SEK",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C",
        };
    }
}
exports.EnFiSek = EnFiSek;
class EnFiDkk {
    constructor() {
        this.locale = "en-fi";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "DKK",
            symbol: "DKK",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C",
        };
    }
}
exports.EnFiDkk = EnFiDkk;
class EnFiNok {
    constructor() {
        this.locale = "en-fi";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "NOK",
            symbol: "NOK",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C",
        };
    }
}
exports.EnFiNok = EnFiNok;
